import React from "react";
import "./notCoveredItem.scss";
import { Col, Row } from "reactstrap";

class NotCoveredItem extends React.Component {
  state = {
    device: "mobile"
  };
  componentDidMount() {
    // console.log(window.screen.availWidth);
    this.setState({
      device: window.screen.availWidth < 850 ? "mobile" : "web"
    });
  }
  render() {
    return (
      <Row className={"m-0 p-0 not-covered-item"}>
        <Col lg={"auto"} xs={"auto"} className={"m-0 p-0"}>
          <img
            className="tick-icon"
            src={require("../../../../assets/images/landing/cross-red-thick.svg")}
            alt=""
          />
        </Col>
        <Col className={"m-0 p-0"}>
          <h3 className="card-sub-title font-weight-bold">
            The{" "}
            <span className=" m-0 plan-name text-capitalize">
              {this.props.plan}
              <span className={"text-capitalize"}>Life</span>
            </span>{" "}
            Plan under Toffee Insurance Plans doesn’t cover any kind of{" "}
            {this.props.section} benefits.
          </h3>
        </Col>
      </Row>
    );
  }
}

export default NotCoveredItem;
